module.exports = __webpack_public_path__ + "static/media/banner.ca969f20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.png
// module id = 940
// module chunks = 31